import $ from 'jquery';
import { fetchAiCredits } from '~graphql/controllers';
import { onErrorShowMessage } from '~src/errors';
import { renderAiSidebar } from '~core/aiEdit/renderAiSidebar';
import { initAiCreditPackagesModal } from './initAiCreditPackagesModal';
import {
  initAiBlackFridayModal,
  isBlackFridayActive,
} from './initAiBlackFridayModal';

export const handleTabImagesAI = async () => {
  // Render the entire AI sidebar using centralized configuration
  renderAiSidebar();

  // Force lazy loading update after a small delay to ensure visibility
  setTimeout(() => {
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update();
    }
  }, 100);

  let credits;
  try {
    credits = await fetchAiCredits();
  } catch (error) {
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Attenzione!',
      confirmButtonColor: '#278e8e',
      text:
        'Errore nel caricamento del saldo crediti IA. Il saldo mostrato potrebbe non essere aggiornato.',
    });
    console.error(error);
    return;
  }

  if (!credits || !credits.edges || !credits.edges[0]) {
    // No credits data available, show 0
    $('#ai-credits-balance').text(0);
    return;
  }

  const totalCredits =
    credits.edges[0].freeCreditsAmount + credits.edges[0].paidCreditsAmount;

  $('#ai-credits-balance').text(totalCredits);

  // Initialize the credit packages modal
  initAiCreditPackagesModal();

  // Initialize the Black Friday modal if promo is active
  if (isBlackFridayActive()) {
    initAiBlackFridayModal();
  }

  // Initialize the credits info modal
  const { initAiCreditsInfoModal } = require('./initAiCreditsInfoModal');
  initAiCreditsInfoModal();

  $('[data-toggle="tooltip"]').tooltip();
};
